module.exports = {
    "tel": "电话",
    "email": "邮箱",
    "contact": "或直接联系我们 ",
    "search": "搜索",
    "result": "搜索结果",
    "search.placeholder": "搜索...",
    "all": "全部",
    "search.title": "标题",
    "search.content": "内容",
    "no.search.result": "如果搜索不到结果",
    "click": "请点击",
    "post.topic": "我要发帖",
    "new.question": "在用户社区中提出问题",
    "qq": "QQ群",
    "advance.search": "高级搜索",
    "search.field": "搜索字段",
    "search.tags": "标签",
    "search.comments": "评论",
    "topic.type": "帖子类型",
    "site": "站内",
    "tut": "相关教程",
    "topic.plate": "板块"
}


// WEBPACK FOOTER //
// ./src/pages/search/i18n/locale.zh-cn.js